# Add Queue

## Name

The descriptive name for your Queue.

## Description

The description of your Queue.

## Creating

Click <v-btn prepend-icon='mdi-playlist-plus' color='primary'>CREATE QUEUE</v-btn> to create your new Queue. To Cancel the changes, click <v-icon>mdi-close-circle</v-icon>.
